/* eslint-disable @typescript-eslint/naming-convention */

import { TimeSlotsForm } from '@components/TimeSlotsForm';
import { BUSINESS_HOURS_TYPE } from '@constants/generic.constants';
import { LineBusinessHoursQuery_getLineBusinessHours as BusinessHours } from '@generated/LineBusinessHoursQuery';
import { useUpdateAgent } from '@hooks/useUpdateAgent/useUpdateAgent';
import { UserProfileTabProps } from '@pages/user-profile/UserProfile.decl';
import { useTranslation } from 'react-i18next';

export function UserProfileBusinessHoursSection({ user }: UserProfileTabProps) {
  const { t } = useTranslation();
  const { updateOpeningHours } = useUpdateAgent(user);

  const handleSubmit = (businessHours: BusinessHours) => updateOpeningHours(businessHours);

  return (
    <TimeSlotsForm
      initialValues={user.businessHours}
      title={t('user_profile.working_hours.title')}
      onSubmit={handleSubmit}
      businessHoursType={BUSINESS_HOURS_TYPE.AGENTS}
    />
  );
}
